export default __webpack_public_path__ + "static/0045-d447e21c1b9486ee6f5a5d57a9f6d659.png";